import { render } from "./m-edit-agency.vue?vue&type=template&id=756b646b"
import script from "./m-edit-agency.vue?vue&type=script&lang=js"
export * from "./m-edit-agency.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__